"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CookieParameter = void 0;
var CookieParameter = exports.CookieParameter = function (a) {
  return a.PairsDelimiter = "; ", a.KeyValueDelimiter = "=", a.MaxAge = "Max-Age", a.Path = "Path", a.Domain = "Domain", a;
}({});